module.exports = __webpack_public_path__ + "img/raiinmaker.4fd99629.png";